import { Identifier, useListContext } from 'react-admin';

export function useOrderAdjustmentIndex(orderId: Identifier | undefined): number {
  const { data: orders = [] } = useListContext();

  return orders.findIndex((order) => order.id === orderId);
}
